import { apiBaseUrl } from "./config"
import { sendDelete, sendGetRequest, sendPostRequest } from "./utils";

const baseUrl = `${apiBaseUrl}/transactions`;

async function getTransactionsConfig() {
  let url = `${baseUrl}/config`;
  const data = await sendGetRequest(url);
  return data;
}

async function getTransactions(filters) {
  let url = `${baseUrl}`;
  let params = [];

  Object.keys(filters).forEach(key => {
    params.push(`${key}=${filters[key]}`);
  });
  if (params.length) {
    url += '?' + params.join('&');
  }

  const data = await sendGetRequest(url);
  return data;
}

async function postTransaction(t) {
  let data = await sendPostRequest(baseUrl, t);
  return data;
}

async function deleteTransaction(transactionId, comunidadId) {
  let data = await sendDelete(`${baseUrl}/${transactionId}`, { comunidadId });
  return data;
}

export {
  getTransactionsConfig,
  getTransactions,
  postTransaction,
  deleteTransaction
};
